import { makeStyles } from '@mui/styles';
import BgImage from './../assets/images/epridm_bg_image.png'

export const useCommonStyles = makeStyles({
	mainContainer: {
		minHeight: '67vh'
	},
	ratingDiv: {
		lineHeight: 'normal',
		display: 'inline-block',
		color: '#fff',
		padding: '2px 4px 2px 6px',
		borderRadius: '3px',
		fontWeight: 600,
		fontSize: '12px',
		verticalAlign: 'middle',
		backgroundColor: '#388e3c'
	},
	itemCls: {
	  transition: 'box-shadow .3s',
	  "&:hover": {
		boxShadow: '0 0 11px rgba(33,33,33,.2)'
	  }
	},
	loginLink: {
		color: '#fff',
		textDecoration: 'none',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'&:hover': {
			backgroundColor: 'transparent',
			color: '#fff'
		}
	},
	formWrapper: {
        background: `url(${BgImage}) no-repeat`,
        backgroundSize: '100% 100%',
        height: '100vh'
    },
	d_f_row_spc_btwn: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	d_f_row_center: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center'
	},
	d_f_column_center: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	w_100: {
		width: '100%'
	},
	h_100: {
		height: '100%'
	},
    logoWrapper: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#fff',
		padding: '8px'
    },
	appLogo: {
		width: '100%',
        maxWidth: '300px',
		height: '120px',
	},
});